<template>
  <div class="main">
    <report-top> </report-top>
    <selectTool>
      <div class="selectToolItem" slot="item">
        <div class="label"><p>车牌号</p></div>
        <div style="width: 120px">
          <selectCar
            :name="searchItem.carNo"
            @update:name="searchItem.carNo = $event"
            :deviceNo="searchItem.deviceNo"
            @update:deviceNo="searchItem.deviceNo = $event"
            clearable
            placement="left"
            filter="油感"
            filterGroup="车辆"
            style="position: relative; width: 200px"
          ></selectCar>
        </div>
      </div>
      <div class="selectToolItem" slot="item">
        <div class="label"><p>时间范围</p></div>
        <start-end ref="startEnd" timeModel="0" :datetime="true"></start-end>
      </div>
      <div class="selectToolItem" slot="item">
        <Button @click="chaxun" type="primary" class="chaxun">查询</Button>
        <Button @click="exportAll" type="error" class="chaxun">导出</Button>
      </div>
    </selectTool>
    <div>
      <oil-draw ref="oil"></oil-draw>
      <oil-list ref="oilList"></oil-list>
    </div>
  </div>
</template>
<script>
import oilDraw from "./oilDraw.vue";
import oilList from "./oilList.vue";

export default {
  components: { oilDraw, oilList },
  data() {
    return {
      searchItem: {
        deviceNo: "",
        carNo: "",
        returnCoord: 2, //返回坐标系（1-WGS84，2-GCJ-02，3-BD-09）,可用值:1,2,3
        endTime: "",
        startTime: "",
        limit: 31,
      },
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.lbs + "/oil/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        this.$refs.oilList.reachData(data);
        if (data.length == 0) {
          this.$Message.error("暂无数据");
        }
        this.total = res.data.data.total;

        var list = [];
        var waveList = [];
        for (const i in data) {
          data[i].gpsTime = this.utils.time(data[i].gpsTime);
          data[i].ocFlag2 = data[i].ocFlag == 1 ? "是" : "否";
          var obj = {
            value: [
              data[i].gpsTime,
              data[i].oilLiters,
              data[i].accStatus == 0 ? "关" : "开",
              data[i].speed,
              data[i].oil,
            ],
          };
          list.push(obj);

          if (data[i].ocFlag != 0) {
            var ddd = [
              data[i].gpsTime,
              data[i].oilLiters,
              data[i].ocOilLitre,
              data[i].ocFlag == 1 ? "加油" : "放油",
            ];
            waveList.push(ddd);
          }
        }
        this.$refs.oil.reData(list, waveList);
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      if (this.searchItem.deviceNo.length == 0) {
        this.$Message.error("信息不完整");
        return;
      }
      var a = this.$refs.startEnd.getTimeObj();
      this.searchItem.startTime = a.start;
      this.searchItem.endTime = a.end;
      //this.utils.jcTime(this.searchItem);

      this.getList();
    },
    search() {
      console.log(this.keyWork);
      this.reset();
      this.getList();
    },
    exportAll() {
      if (this.searchItem.deviceNo.length == 0) {
        this.$Message.error("信息不完整");
        return;
      }
      var a = this.$refs.startEnd.getTimeObj();
      this.searchItem.startTime = a.start;
      this.searchItem.endTime = a.end;
      var params = [
        {
          name: "deviceNo",
          value: this.searchItem.deviceNo,
        },
        {
          name: "startTime",
          value: this.searchItem.startTime,
        },
        {
          name: "endTime",
          value: this.searchItem.endTime,
        },
        {
          name: "returnCoord",
          value: 2,
        },
      ];

      this.utils.exportData(this.axios.lbs + "/oil/export", params);
    },
    reset() {},
  },
};
</script>
<style lang="">
#oil_wrap {
  width: 100%;
  height: calc(100% - 100px);
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// ../common/src/components/oil/oil.vue